<template>
  <div class="container">
    
    <!-- BANNER NATALE
    <div>
      <h1 class="titleBanner"> Dalla Nostra associazione </h1>
      <img src="../assets/BabboNatale.png" class="hoverImg imgNatale" alt="Babbo Natale"/>  
    </div>
    -->
    <!-- BANNER PASQUA
    <div>
      <h1 class="titleBanner"> Dalla Nostra associazione </h1>
      <img src="../assets/pasqua.jpg" class="hoverImg imgNatale" alt="Buona Pasqua"/>  
    </div>
     -->

    <!-- BANNER ASSEMBLEA
    <div class="assemblea">
      <p class="location">Forlimpopoli, 02/02/2024</p>
      <h4 class="what">Assemblea dei soci avis 23/02/2021 ore 20.30</h4>
      Carissimo/a ti invito a partecipare all'Assemblea Annuale Ordinaria dei soci 
      AVIS FORLIMPOPOLI ODV e alla cerimonia della premiazione dei donatori
      che si terrà presso <b> il CINEMA TEATRO VERDI in Piazza Fratti 7, Forlimpopoli,</b> il giorno 22/02/2024 
      alle ore 05.00 in prima convocazione ed in <b>seconda convocazione il giorno</b> <b color='red'>23/02/2024 
      alle ore 20,30</b> con il seguente</p>
      <p class="center">ORDINE DEL GIORNO</p>
      <ul class="listDecimal">
        <li>Nomina Segretario dell'assemblea;</li>
        <li>Relazione del Presidente sulle attività svolte e future;</li>
        <li>Relazione del tesoriere sul bilancio consuntivo 2023 e preventivo 2024;</li>
        <li>Discussione ed approvazione delle relazioni;</li>
        <li>Nomina delegati all’Assemblea Provinciale;</li>
        <li>Saluto alle autorità presenti;</li>
        <li>Premiazione dei donatori benemeriti, in base alle donazioni effettuate al 30/06/2023;</li>
        <li>Estrazione, fra i presenti, di simpatici premi;</li>
        <li>Saluti conclusivi e distribuzione pacco dono a tutti i soci presenti;</li>
      </ul>
      <p class="otherText">Se sei impossibilitato a partecipare, come previsto all'art.8.c5 dello statuto in essere, 
        puoi essere rappresentato da altro socio donatore munito di delega, che trovi unita alla presente. <br/><br/>
      <b>Vista l’importanza degli argomenti all’ordine del giorno, si raccomanda la massima partecipazione.</b>
      </p>
    </div>

    <div class="assemblea">
      <h4 class="what">RITIRO PACCO DONO</h4>
      <p>Tutti i soci iscritti all’AVIS Forlimpopoli ODV hanno diritto a ricevere il pacco dono
        che quest’anno consiste in un alimento per aiutare una ditta che ha subito danni dall’alluvione di maggio scorso, 
        IL TERMINE ULTIMO PER IL RITIRO SARA’ IL 24 APRILE 2024.
        Il pacco dono potrà essere ritirato al termine dell’assemblea oppure presso la sede, 
        in via Duca d’Aosta 33, tutti i mercoledì dalle 17 alle 19 fino al 24 aprile 2024. 
        In via eccezionale la sede rimarrà aperta anche dal 26/02/2024 al 01/03/2024 compresi, 
        dalle ore 17.00 alle ore 19.00 e sabato 24/02/2024 e 02/03/2024 dalle ore 08.30 alle ore 12.30.</p>
    </div>

    <div class="assemblea">
      <h4 class="what">SANTA MESSA</h4>
      <p>Domenica 25/02/2024 alle ore 10.00 presso la Chiesa di S. Spirito, sarà celebrata una Santa Messa 
          per l’associazione AVIS Forlimpopoli ODV ed in suffragio di tutti i soci defunti.</p>
    </div>-->
    <!-- 
    <br/><br/>-->

    <!--<div class="assemblea">
      <h4 class="what RED">Contributo alluvione </h4>
        <p class="otherText">Avis Forlimpopoli ha contribuito con 800 euro di viveri ad aiutare gli alluvionati. </br>
        Nella foto il presidente che, con gli altri volontari Avis, il <b> 23 Maggio </b>, ha aiutato la protezione civile nello smistamento degli alimenti. <br/>
          <img src="../assets/alluvione.jpg" class="hoverImg imgNatale" alt="Aiuto alluvionati"/>  
      </p>
    </div> -->

    <!--<div class="assemblea">
      <h4 class="what RED">NOTIZIE IN EVIDENZA </h4>
        <p class="otherText"> Noi volontari Avis Forlimpopoli saremo in piazza Garibaldi il 10 e il 17 Dicembre con un punto informativo per nuove adesioni e con i cuori di ciollolato Telethon per sostenere la ricerca sulle malattie genetiche rare.
          <img src="../assets/telethon2.jpg" class="hoverImg imgNatale" alt="DONAZIONE"/> 
        </p>         
    </div>
    </br></br>
    <div class="assemblea">
      <h4 class="what RED"> AVIS VI AUGURA UN BUON NATALE</h4>
      <img src="../assets/Natale2023.jpeg" class="hoverImg imgNatale" alt="Natale 2023"/>
    </div>
    </br></br>
    --> 
   <!--
    <div class="assemblea">
      <h4 class="what RED">SEGAVECCHIA 2023 </h4>
        <p class="otherText">Nelle giornate dall' <b>11 Marzo al 19 Marzo </b>torna la Segavecchia di Forlimpopoli.<br/>
          Per la tombola gestita da Avis Forlimpopoli, l'estrazione si terrà il <b>19 Marzo</b> ore <b>21:00</b> in <b>Piazza Garibaldi</b>.<br/>
          Le cartelle si potranno acquistare presso il gazebo allestito in piazza Garibaldi.
          <img src="../assets/segavecchia2.jpg" class="hoverImg imgNatale" alt="Segavecchia 2023"/>  
      </p>
    </div>

     

    <div class="assemblea">
      <h4 class="what RED">17 LUGLIO 2022 - MIRABILANDIA RELOADED</h4>
        <p class="otherText">Unisciti ad AVIS nella giornate del <b>17 Luglio 2022</b>.<br/>
        <img src="../assets/mirabilandida.png" @click="redirectToArticleAVIS" class="hoverImg fiori" alt="Fiorimpopoli 2022"/>
      </p>
    </div>
    
    <br/>
    <div class="Gesto">
      <h4 class="what RED">Facciamo un gesto concreto</h4>
      <img src="../assets/GESTO.jpg" class="hoverImg fiori" alt="Facciamo un gesto concreto"/>
      <img src="../assets/dona.jpg" class="hoverImg fiori" alt="Facciamo un gesto concreto"/>
    </div>
    <br/>
    <div class="assemblea">
      <h4 class="what">Avviso ai Donatori AVIS </h4>
        <p class="otherText">Come visibile nell’agenda on-line di prenotazione, dal 2022 si dona anche una domenica ogni mese 
        <br/>(escluso  Giugno, Luglio, Agosto e Settembre).<br/>
        </p>
        <br/><br/>
        <p class="otherText">Si è deciso per le giornate <b>TELETHON (16,17 e 18 Dicembre)</b> di:
        <ul>
          <li> Partecipare e portare, in occasione del <b>mercatino della Segavecchia (1 Dicembre)</b>, i cuori di cioccolata TELETHON </li>
          <li> Il <b>16 e 17 Dicembre</b> si farà il banchetto presso il Conad</li>
          <li> Il <b>16, 17 e 18 Dicembre</b> si farà il banchetto presso il Bennet e in piazza </li>
        </ul>
        </p>
        <p class="otherText"> Si è deciso per il <b>mercatino della Segavecchia (13 Novembre e 11 Dicembre)</b> di partecipare con banco informativo</p>
    </div>
    -->
    <div class="bannerVaccino">
      <div><p class="textBanner">Notizie in evidenza</p></div>
      <hr/>
      <div class="styleImg">
        <img src="../assets/DonaTu.jpg" class="hoverImg Natale" alt="dona"/> 
      </div>
    </div>
    <hr/>
    <div class="newApp">
      <h3 class="darkblue">Donare sangue è sempre importante e oggi più semplice con la prenotazione</h3>
      <div> 
        <p class="justifyText">
          Hai ricevuto l’SMS di convocazione alla donazione? <br/>
          Prenota la tua donazione di sangue o plasma al link <a href="https://udrforli.mesis.it/"> https://udrforli.mesis.it/</a> si accede direttamente all’Agenda online.
          É così possibile prenotare la propria donazione di sangue o plasma presso i 3 punti di raccolta: Forlì, Modigliana e Santa Sofia. E’possibile prenotare al massimo con 2 giorni di anticipo rispetto a quello desiderato. 
          Occorre inserire i dati richiesti si procede alla prenotazione che verrà confermata tramite una mail nella quale è riportato il codice di prenotazione, che sarà utile per eventuali modifiche dell’appuntamento. 
          Quanto specificato è valido sia per i donatore che per gli aspiranti donatori.
          <br/>
          Prenotare la donazione è importante: ci aiuta a programmare meglio la raccolta.
        </p>
        <p class="justifyText">I vantaggi della prenotazione:</p>
        <ul class="justifyText listable">
          <li>Eliminazione tempi di attesa telefonici</li>
          <li>Scelta precisa della data e orario della donazione</li>
          <li>Maggior efficienza della struttura</li>
          <li>Recupero risorse</li>
        </ul>
      </div>
    </div>
    <div class="banner5X1000">
      <img src="../assets/Banner-5x1000.png" class="hoverImg" style="width:100%" alt="5x1000"/>
      <only-text :title2=titleBanner :text=onlyText :coloredText=colored :text12=text12
      :coloredText2=coloredText2 :text3=text13></only-text>     
    </div>
    <hr/>
    <only-text title2="IL PROBLEMA" :text=textHomeText></only-text>  
    <p>- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - </p>   
    <only-text title2="LA SOLUZIONE"></only-text> 
    <h1 class="titleBanner">Dona sangue o plasma</h1>
    <h3 class="titleTextBanner">Per iniziare a donare è sufficiente rispettare alcuni semplici requisiti</h3><br/><br/>
    <div class="flipflop">
      <div class="flip-container" ontouchstart="this.classList.toggle('hover');">
        <div class="flipper">
          <div class="front">
            <div>
              <img class="vc_single_image-img " src="../assets/name.svg" alt="Donatore" title="Donatore" /><br/><br/>
              <h1 class="titleBanner">18 - 60 anni</h1><br/><br/>
              <p class="infoFlip">Età necessaria per iniziare a donare.</p>
            </div>
          </div>
          <div class="back" >
            <!-- back content -->
            <div class="text">
              <h1 class="titleBanner">PER I DONATORI PERIODICI</h1><br/><br/>
              <p class="infoFlip">La donazione può essere consentita fino a 60 anni, previa valutazione clinica del medico.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="flip-container" ontouchstart="this.classList.toggle('hover');">
        <div class="flipper">
          <div class="front">
            <!-- front content -->
            <div>
              <img class="vc_single_image-img " src="../assets/weight-scale.svg" alt="Peso Donatore" title="Peso Donatore" /><br/><br/>
              <h1 class="titleBanner">50 kg</h1><br/><br/>
              <p class="infoFlip">Peso minimo necessario del donatore per effettuare una donazione.</p>
            </div>
          </div>
          <div class="back">
            <!-- back content -->
            <div class="text">
              <h1 class="titleBanner">PER UOMINI E DONNE</h1>
              <p class="infoFlip">Questa regola è valida per qualunque donatore, indipendentemente dal suo sesso.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="flip-container" ontouchstart="this.classList.toggle('hover');">
        <div class="flipper">
          <div class="front">
            <!-- front content -->
            <div>
              <img class="vc_single_image-img " src="../assets/heart.svg" alt="Donatore" title="Donatore" /><br/>
              <h1 class="titleBanner">Buono stato di salute</h1><br/><br/>
              <p class="infoFlip">Il donatore deve godere di un buono stato di salute per iniziare a donare.</p>
            </div>
          </div>
          <div class="back">
            <!-- back content -->
            <div class="text">
              <h1 class="titleBanner">VALORI NELLA NORMA</h1><br/><br/>
              <p class="infoFlip">La pressione arteriosa del donatore deve essere nella norma, la sua frequenza cardiaca tra i 50 e 100 battiti al minuto ed 
                emoglobina con valori minimi necessari. </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr/>
    <div class="news">
      <div class="innerNews">
        <div>
          <div class="relatedNews">
            <p class="title">News correlate</p>
          </div>
          <div class="event">
            <b-carousel
              id="carousel-1"
              :interval="4000"
              controls
              indicators
              background="#ababab"
              img-width="1024"
              img-height="480"
              style="text-shadow: 1px 1px 2px #333;"
              
            >
              <b-carousel-slide>
                <template #img>
                  <img
                    class="d-block img-fluid w-100 hoverImg"
                    width="0"
                    height="0"
                    src="../assets/40anniversario2.jpg"
                    alt="image slot"
                    @click="redirect"
                  >
                </template>
              </b-carousel-slide>
              <b-carousel-slide>
                <template #img>
                  <img
                    class="d-block img-fluid w-100 hoverImg"
                    width="500"
                    height="500"
                    src="../assets/telethonCuore.jpg"
                    alt="image slot"
                    @click="redirectToArticle"
                  >
                </template>
              </b-carousel-slide>
              <b-carousel-slide>
                <template #img>
                  <img
                    class="d-block img-fluid w-100"
                    width="500"
                    height="500"
                    src="../assets/segavecchia.jpg"
                    alt="image slot"
                    @click="redirectToArticleSV"
                  >
                </template>
              </b-carousel-slide>
              <b-carousel-slide>
                <template #img>
                  <img
                    class="d-block img-fluid w-100 hoverImg"
                    width="500"
                    height="500"
                    src="../assets/fiorimpopoli1.jpeg"
                    alt="image slot"
                  >
                </template>
              </b-carousel-slide>
            </b-carousel>
          </div>
        </div>
    </div>

    <div class="innerNews">
      <div class="relatedNews">
        <p class="title">Eventi sul territorio</p>
      </div>
      <div class="event">
        <p style="max-width:95%; margin:10px auto; text-align:justify">Al momento gli eventi sono sospesi a seguito delle recenti restrizioni COVID-19. 
          <br/>Speriamo di poter ritornare il prima possibile e di poter organizzare nuovi eventi.
        </p>
      </div>
    </div>
      
    </div>
  </div>
</template>

<script>
import onlyText from '../views/reusableComponent/onlyText.vue'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'


export default {
  data() {
    return {
      source1: '../locales/PROGRAMMA_FIORIMPOPOLI_2022.pdf',
      publicPath: process.env.BASE_URL,
      titleBanner: "Dona il tuo 5x1000 ad AVIS Forlimpopoli",
      onlyText: "Anche quest'anno potrai sostenere con la tua dichiarazione dei redditi",
      colored: " AVIS COMUNALE FORLIMPOPOLI. ",
      text12: "È facile e non comporta alcuna spesa aggiuntiva.\n"+
      "I modelli per la dichiarazione dei redditi CU, 730 e UNICO hanno uno spazio dedicato al 5 per mille, in cui puoi "+
      "firmare indicando il codice fiscale di",
      coloredText2: "AVIS Forlimpopoli 80014660403",
      text13: "nella sezione relativa al Sostegno degli enti"+ 
      "di volontariato. Anche chi non compila la dichiarazione dei redditi, ovvero chi ha solo il modello CU fornito dal "+
      "datore di lavoro o dall’ente erogatore della pensione, può destinare il 5 per mille.\n\nGrazie da AVIS Forlimpopoli!",
      textHomeText: "Il sangue umano è un prodotto naturale, non riproducibile artificialmente e indispensabile alla vita.\n"+
      "Indispensabile nei servizi di primo soccorso, in chirurgia nella cura di alcune malattie tra le quali quelle oncologiche e nei trapianti.\n"+
      "Pensa di essere tu al loro posto."
    }
  },
  components: {
    onlyText,
     VuePdfEmbed,
  },
  methods: {
    onSlideStart() {
      this.sliding = true
    },
    onSlideEnd() {
      this.sliding = false
    },
    redirect() {
      this.$router.push('/news')
    },
    redirectToArticle(){
      window.open('https://www.ilrestodelcarlino.it/forl%C3%AC/cronaca/forlimpopoli-donati-700-pacchi-1.5874766')
    },
    redirectToArticleSV(){
      window.open('https://www.segavecchia.it/note.php?note_id=2462221907223205##cookieOk')
    },
    redirectVaccino() {
      this.$router.push('/news-vaccino')
    },
    redirectToArticleAVIS(){
      window.open('https://www.avis.it/it/mirabilavis-reloaded')
    },
    redirectBurioni() {
      this.$router.push('/news-burioni')
    }
  }
}

</script>

<style lang="sass">
@import './Home' 

</style>